import React from 'react';
import { useTranslation } from 'react-i18next';
import css from '../../summary-view.module.css';
import SummaryGraph from '../../summary-graph';
import { formatDateValue } from '../../../../../services/utils';
import { FatProteinEntry } from '../../../../../interfaces/livestock-metabolism';

interface MetabolismData {
  fatAndProtein: FatProteinEntry[];
  avgFat: number | null;
  avgProtein: number | null;
}

export default function FatAndProteinSummary({
  metabolismData,
}: {
  metabolismData: MetabolismData;
}) {

  const { t } = useTranslation();
  const reversedMetabolismInfo = [...metabolismData.fatAndProtein].reverse();

  return (
    <div className={css['summary-container']}>
      <div className={css['left-panel']}>
        <div className={css['grid-container']}>
          <SummaryGraph
            title={t('pages.livestock.summary.view.milk_composition')}
            height={193}
            xKey="current_date"
            yLeftValue={`%, ${t('pages.livestock.summary.view.produce_measurement')}`}
            yRightValue={t('pages.livestock.summary.view.protein_difference')}
            dataObjects={[
              {
                dataKey: "interval",
                dataTitle: t('pages.livestock.summary.view.protein_interval'),
                strokeColor: "#12589F",
                yAxis: "left"
              },
              {
                dataKey: "fat",
                dataTitle: t('pages.livestock.summary.section.fat'),
                strokeColor: "#50AE2F",
                yAxis: "left"
              },
              {
                dataKey: "protein",
                dataTitle: t('pages.livestock.summary.section.protein'),
                strokeColor: "#E791A9",
                yAxis: "left"
              },
              {
                dataKey: "difference",
                dataTitle: t('pages.livestock.summary.view.protein_difference'),
                strokeColor: "#A97E81",
                yAxis: "right"
              }
            ]}
            data={metabolismData.fatAndProtein}
            allowDecimal={true}
          />

          <p className={css['summary']}>{t('pages.livestock.summary.view.year_average')}</p>
          <hr></hr>

          <table className={css['under-table']}>
            <tbody className={css['strong']}>
              <tr>
                <td>{t('pages.livestock.summary.view.fat_percentage')}</td>
                <td>{metabolismData.avgFat}</td>
              </tr>

              <tr>
                <td>{t('pages.livestock.summary.view.protein_percentage')}</td>
                <td>{metabolismData.avgProtein}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className={css['left-panel']}>
        <table className={css['table']} style={{ width: '90%' }}>
          <thead>
            <tr>
              <th>{t('pages.livestock.summary.view.date')}</th>
              <th>{t('pages.livestock.summary.section.fat')}</th>
              <th>{t('pages.livestock.summary.section.protein')}</th>
              <th>{t('pages.livestock.summary.view.protein_interval')}</th>
              <th>
                {t('pages.livestock.summary.view.protein_difference')}
              </th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(reversedMetabolismInfo).map(([index, data]) => (
              <tr key={index}>
                <td>{formatDateValue(data.current_date)}</td>
                <td>{data.fat}</td>
                <td>{data.protein}</td>
                <td>{data.interval}</td>
                <td>{data.difference}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
